/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_023: Question = {
  id: 'pres-023-types-milieux-humides',
  oldId: '37',
  title: 'Nombre de types différents de milieux humides présents sur le territoire',
  number: '3.7',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

export const question_pres_023_v2: Question = question_pres_023;
export const question_pres_023_v3: Question = question_pres_023;
